module.exports = __webpack_public_path__ + "img/IMG_2834.6ada2061.jpg";